import styled from 'styled-components'
import CLButton from 'syf-component-library/ui/atoms/Button/Button'
import theme from 'theme'

export const AddAccountButtonStyle = styled(CLButton)`
  margin: 0;
  height: auto;
  background-color: transparent;
  color: ${theme.white};
  border-color: ${theme.white};
  &:hover {
    color: ${theme.cyanBlue};
  }
`

export const AddAccountButtonIconWrapper = styled.div`
  margin: 0px;
`

export const AddAccountButtonWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 4px;
`

export const AddAccountTextWrapper = styled.div`
  display: flex;
  text-align: left;
`
